import { Typography } from 'antd';
import { useEffect, useRef } from 'react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from '../../../store/app.hooks';
import { Page } from '../../../common/constants/pageAction';
import BreadCrumbs from '../../../common/components/Breadcrumbs';
import { clearConfigDataRetention } from '../../../store/master/dataRetention/dataRetention.reducer';
import { IConfigDataRetentionProps } from './dataRetention.model';
import MainTable from './MainTable/index';
import EditDataRetentionModal from './EditDataRetentionModal';

// Settings for dbo.uspM360_DataRetention: one row per step, in the order the procedure runs them.
// Steps come from the deployment script, so this page only views them and edits their settings.
const ConfigDataRetention: React.FC<IConfigDataRetentionProps> = (props) => {
  const dispatch = useAppDispatch();
  const dataTableRef = useRef(null);
  const history = useHistory();

  const { id: urlId } = props.match?.params;

  const [editModalVisible, setEditModalVisible] = React.useState(false);
  const [id, setId] = React.useState(0);

  useEffect(() => {
    if (+urlId > 0) {
      setEditModalVisible(true);
      setId(+urlId);
    }
  }, [+urlId]);

  useEffect(() => {
    return () => {
      dispatch(clearConfigDataRetention());
    };
  }, []);

  const refreshDataTable = () => {
    dataTableRef?.current.refreshData();
  };

  return (
    <div className="sqlServer">
      <div className="title-block">
        <h4 className="p-0">
          <BreadCrumbs pageName={Page.ConfigDataRetention} />
        </h4>
        <Typography.Text type="secondary">
          What data retention (uspM360_DataRetention) deletes: one row per table, in the order it
          runs. Edit a row to change how many months it keeps, switch it off, or keep each
          Tenant/Company/BU&apos;s latest dataset.
        </Typography.Text>
      </div>
      <div className="main-card">
        <MainTable
          ref={dataTableRef}
          setSelectedId={(id) => {
            setId(id);
            setEditModalVisible(true);
          }}
        />
      </div>
      {editModalVisible && (
        <EditDataRetentionModal
          showModal={editModalVisible}
          handleModalClose={() => {
            setEditModalVisible(false);
            history.push('/administration/config-data-retention');
          }}
          id={id}
          refreshDataTable={() => refreshDataTable()}
        />
      )}
    </div>
  );
};

export default ConfigDataRetention;
